export const GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL = '/reservation/getByResId'
export const GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL = '/reservation/getByLicensePlateAndUpdateDriver'
export const UPDATE_RESERVATION_URL = '/reservation/store'
export const CHECKIN_RESERVATION_URL = '/reservation/checkIn'
export const SET_RESERVATION_DRIVERS_URL = '/reservation/setDrivers'
export const LOGIN_URL = '/login'
export const LOGOUT_URL = '/logout'
export const GET_TERMINAL_INFO_BY_ID_URL = '/api/terminal'
export const GET_UI_CONFIG_URL = '/configuration'
